/**
 * Subtle looping background video for hero / section backgrounds.
 * Serves WebM (VP9) first for Chromium/Firefox; MP4 (H.264) as fallback for Safari.
 * Slight black overlay only — keeps the footage's natural colours.
 */
export default function VideoBackground({
  opacity = "opacity-90",
  overlayClass = "bg-black/30",
  testId = "background-video",
}) {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <video
        data-testid={testId}
        className={`absolute inset-0 w-full h-full object-cover ${opacity}`}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        controls={false}
        disablePictureInPicture
      >
        <source src="/media/avm-bg.webm" type="video/webm" />
        <source src="/media/avm-bg.mp4" type="video/mp4" />
      </video>
      <div className={`absolute inset-0 ${overlayClass}`} />
    </div>
  );
}
